import { render, staticRenderFns } from "./bg2Step.vue?vue&type=template&id=5177a670&scoped=true"
import script from "./bg2Step.vue?vue&type=script&lang=js"
export * from "./bg2Step.vue?vue&type=script&lang=js"
import style0 from "./bg2Step.vue?vue&type=style&index=0&id=5177a670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177a670",
  null
  
)

export default component.exports